import React from 'react'
import Nav from '../components/Nav'
import Hero from '../components/Hero'
import Services from '../components/Services'
import WhyUs from '../components/WhyUs'
import Testimonials from '../components/Testimonials'
import ContactForm from '../components/ContactForm'
import Footer from '../components/Footer'

const Home: React.FC = () => {
  return (
    <div className='flex flex-col min-h-screen'>
      <Nav />
      <Hero />
      <Services />
      <WhyUs />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  )
}

export default Home
